import { useContext } from "react";
import $ from "jquery";
import { GlobalContext } from "../GlobalContext";
import { useNoteAlert } from "../pleaseNote";
import { ORDER_COMMENTS_ALERT, PAYMENT_METHOD_STRING, PONUMBER_REQUIRED, SHIPPING_METHOD } from "../../constants";
import { isValidNumber, normalizePath } from "../../Layout/Common/common";

export const useCheckPoNumberRules = () => {
  const { poNumberRules, selectedPaymentType, poNumberRequired, deliveryMethod } = useContext(GlobalContext);

  const { showNoteAlert, showModelAlert } = useNoteAlert();

  const checkPoNumberRules = (poNumber, orderCommands) => {
    const rules = poNumberRules;
    const customErrorMessage =
      rules?.po_error_message === true && rules?.po_error_message_value !== "" ? rules?.po_error_message_value : null;

    if (poNumberRequired == true && !poNumber) {
      showModelAlert({
        content: customErrorMessage ?? PONUMBER_REQUIRED.content,
        title: "PO Rules Violation",
        closeBtnFunction: () => {
          $("#poNumbertextbox").focus();
        },
      });
      return false;
    } else if (deliveryMethod == SHIPPING_METHOD[3] && !orderCommands) {
      showNoteAlert(ORDER_COMMENTS_ALERT.content, ORDER_COMMENTS_ALERT.title);
      return false;
    }
    if (!poNumberRules) return true;

    const selectedPayments = selectedPaymentType ? normalizePath(PAYMENT_METHOD_STRING[selectedPaymentType]) : null;
    if (
      (selectedPayments && selectedPayments === normalizePath(rules.po_payment_options)) ||
      rules.po_payment_options === "ALL"
    ) {
      if (poNumber !== "") {
        if (rules.po_start_with === true && rules.po_start_with_value !== null) {
          if (!String(poNumber).startsWith(rules.po_start_with_value)) {
            showModelAlert({
              content:
                customErrorMessage ??
                `Purchase order number must be start with '${rules.po_start_with_value}'. Please verify and continue.`,
              title: "PO Rules Violation",
              closeBtnFunction: () => {
                $("#poNumbertextbox").focus();
              },
            });
            return false;
          }
        }
        if (rules.po_must_have_number_only === true) {
          if (!isValidNumber(poNumber)) {
            showModelAlert({
              content:
                customErrorMessage ??
                "The Purchase order number must contain numbers only. Please verify and continue.",
              title: "PO Rules Violation",
              closeBtnFunction: () => {
                $("#poNumbertextbox").focus();
              },
            });
            return false;
          }
        }
        if (rules.po_character_length === true && rules.po_character_length_value) {
          if (String(poNumber).length !== rules.po_character_length_value) {
            showModelAlert({
              content:
                customErrorMessage ??
                `The Purchase order number must be '${rules.po_character_length_value}' characters only. Please verify and continue.`,
              title: "PO Rules Violation",
              closeBtnFunction: () => {
                $("#poNumbertextbox").focus();
              },
            });
            return false;
          }
        }
      }
    }

    return true;
  };

  return checkPoNumberRules;
};
